import { Branch, Contact } from './';
import {JsonProperty} from 'json-typescript-mapper';
export class Marketplace {

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('marketplaceNumber')
  public marketplaceNumber?: string;

  @JsonProperty('name')
  public name?: string;

  @JsonProperty('keyword')
  public keyword?: string;

  @JsonProperty('description')
  public description?: string;

  @JsonProperty('particularities')
  public particularities?: string;

  @JsonProperty('street')
  public street?: string;

  @JsonProperty('zipcode')
  public zipcode?: string;

  @JsonProperty('city')
  public city?: string;

  @JsonProperty('federalState')
  public federalState?: string;

  @JsonProperty('place')
  public place?: string;

  @JsonProperty('placeDescription')
  public placeDescription?: string;

  @JsonProperty('alternativePlace')
  public alternativePlace?: string;

  @JsonProperty('sanitaryLocation')
  public sanitaryLocation?: string;

  @JsonProperty('latitude')
  public latitude?: string;

  @JsonProperty('longitude')
  public longitude?: string;

  @JsonProperty('branchString')
  public branchString?: string;

  @JsonProperty('updated')
  public updated?: any;

  @JsonProperty('created')
  public created?: any;

  @JsonProperty('gguid')
  public gguid?: string;

  @JsonProperty({clazz: Branch, name: 'branch'})
  public branch?: Branch;




  constructor(input?: any) {
    this.id = void 0;
    this.marketplaceNumber = void 0;
    this.name = void 0;
    this.keyword = void 0;
    this.description = void 0;
    this.particularities = void 0;
    this.street = void 0;
    this.zipcode = void 0;
    this.city = void 0;
    this.federalState = void 0;
    this.place = void 0;
    this.placeDescription = void 0;
    this.alternativePlace = void 0;
    this.sanitaryLocation = void 0;
    this.latitude = void 0;
    this.longitude = void 0;
    this.branchString = void 0;
    this.updated = void 0;
    this.created = void 0;
    this.gguid = void 0;
    this.branch = void 0;

    if (input) {
      Object.assign(this, input);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/marketplace.model.ts